/**
 * 哈勃用户行为分析监控状态枚举
 */
enum HB_STATUS {
  DISABLED,
  SETUP,
  WAIT_RUNNING,
  RUNNING,
  PAUSED,
  DESTROY
}

export default HB_STATUS;
